import React from "react"
import Block from "@bappweb/block"
import "../assets/style.scss"
import Link from "@bappweb/link"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue } from "@smpu-web/utils/utils"

const LandingHeader = () => {
  let size = useDeviceSize()
  size = size === undefined ? Sizes.md : size
  const isHigherThanMd = size > Sizes.md ? true : false

  const sessionData = useAppSelector((state) => state.sessionData.response)

  return (
    <Block className="banner image-top">
      <Block className="container position-relative">
        <Link href="https://www.akbank.com/" className="logo">
          <img className="logo" src={"./img/kredi-karti/logo.svg"} alt="Akbank logosu" />
        </Link>
        <Block type="section" className="section general-features header-text-container" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "CreditCard.CampaignText.Landing.v2.Top") }} />
        {isHigherThanMd &&
          <picture>
            <source
              data-srcset="./img/kredi-karti/credit_card.png, ./img/kredi-karti/credit_card@2x.png 2x"
              data-src="./img/kredi-karti/transparent.png"
            />
            <img
              className="lazyload img-fluid banner-img"
              src={"./img/kredi-karti/credit_card.png"}
              alt="Kredi kartları: Axess ve Wings görseli"
            />
          </picture>
        }
      </Block>
    </Block>
  )
}

export default LandingHeader
